import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Rows, LocalizedDateTime, LocalizedText, SortedTable, EmptyTablePlaceholder, WithLabel } from 'labguard-cdk'
import { useQuery } from 'react-apollo'
import styles from './AlertComments.scss'

const query = gql`
  query alertCommentsById($alarmId: ID!) {
    alarm(id: $alarmId) {
      id
      alertComments {
        date
        username
        comment
      }
    }
  }
`

const columns = [
  {
    dataKey: 'date',
    width: 150,
    flexGrow: 0,
    flexShrink: 0,
    label: <LocalizedText id="WEB_DATE" />,
    // eslint-disable-next-line react/prop-types, react/display-name
    cellRenderer: ({ cellData }) => <LocalizedDateTime value={cellData} />,
  },
  {
    dataKey: 'comment',
    disableSort: true,
    width: 350,
    flexGrow: 1,
    label: <LocalizedText id="WEB_NOTE" />,
  },
  {
    dataKey: 'author',
    width: 350,
    flexGrow: 1,
    label: <LocalizedText id="WEB_AUTHOR" />,
    // eslint-disable-next-line react/prop-types, react/display-name
    cellDataGetter: ({ rowData: comment }) => `${comment.username}`,
  },
]

const noRowsRenderer = () => (
  <EmptyTablePlaceholder>
    <LocalizedText id="WEB_NO_NOTE" />
  </EmptyTablePlaceholder>
)

const AlertComments = ({ alarmId }) => {
  const { loading, data: { alarm: { alertComments = [] } = {} } = {} } = useQuery(query, { variables: { alarmId } })
  return (
    <Rows>
      <WithLabel topLabel={<LocalizedText id="WEB_NOTES" />} stretch>
        {() => (
          <SortedTable
            className={styles.table}
            loading={loading}
            data={alertComments}
            noRowsRenderer={noRowsRenderer}
            columns={columns}
          />
        )}
      </WithLabel>
    </Rows>
  )
}

AlertComments.propTypes = {
  alarmId: PropTypes.string,
}

export default AlertComments
